::-webkit-scrollbar {
	-webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
	width: 11px;
	background: rgb(236, 236, 236);
}

::-webkit-scrollbar-button:increment,
::-webkit-scrollbar-button {
	display: none;
}
::-webkit-scrollbar:horizontal {
	height: 10px;
}

::-webkit-scrollbar-thumb {
	background-color: #cacaca;
}
::-webkit-scrollbar-track {
	border-radius: 10px;
}
